import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "GPIBYWEALTH",
  title: defineMessage({
    id: "fig.equity.GPIBYWEALTH.title",
    defaultMessage: `Gender parity index for selected education indicators, interaction with wealth`,
  }),
  caption: defineMessage({
    id: "fig.equity.GPIBYWEALTH.caption",
    defaultMessage: `Disparity accumulates for poor girls in low-income-countries and for poor boys in middle- and high-income-countries.`,
  }),
  source: defineMessage({
    id: "fig.equity.GPIBYWEALTH.source",
    defaultMessage: `GEM Report team analysis based on household surveys`,
  }),
};
